/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../../common/time';
import './gift_card_tag';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "giftcard": {
        "nested": {
          "model": {
            "nested": {
              "CardType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "PHYSICAL": 1,
                  "ELECTRONIC": 2,
                  "THIRD_PARTY": 3
                }
              },
              "AttributedMoney": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "money": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GiftCard": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "panFideliusToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "state": {
                    "type": "squareup.giftcard.model.GiftCard.State",
                    "id": 5,
                    "rule": "optional"
                  },
                  "balance": {
                    "type": "squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "thirdPartyCardFideliusToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "pin": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "detail": {
                    "type": "squareup.giftcard.model.GiftCard.Detail",
                    "id": 9,
                    "rule": "optional"
                  },
                  "isElectronic": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "egiftOrderDetails": {
                    "type": "squareup.giftcard.model.GiftCard.EGiftOrderDetails",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cardType": {
                    "type": "squareup.giftcard.model.CardType",
                    "id": 12,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 13,
                    "rule": "optional"
                  },
                  "ganFideliusToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "ganSource": {
                    "type": "squareup.giftcard.model.GiftCard.GANSource",
                    "id": 17,
                    "rule": "optional"
                  },
                  "registeredAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 15,
                    "rule": "optional"
                  },
                  "egiftThemeToken": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "tags": {
                    "type": "squareup.giftcard.model.GiftCardTag",
                    "id": 18,
                    "rule": "repeated"
                  },
                  "parentMerchantToken": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "UNKNOWN": 0,
                      "GENERATED": 1,
                      "UNREGISTERED": 2,
                      "REGISTERED": 3,
                      "ACTIVE": 4,
                      "BLOCKED": 5,
                      "RETIRED": 6
                    }
                  },
                  "Detail": {
                    "fields": {
                      "loadedBalance": {
                        "type": "squareup.giftcard.model.AttributedMoney",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "EGiftOrderDetails": {
                    "fields": {
                      "recipientEmailId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "recipientName": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "senderEmailId": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "senderName": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "senderCustomMessage": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "scheduledDeliverAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 8,
                        "rule": "optional"
                      },
                      "deliveryState": {
                        "type": "squareup.giftcard.model.GiftCard.EGiftOrderDetails.DeliveryState",
                        "id": 9,
                        "rule": "optional"
                      },
                      "butterDeliveryToken": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "recipientContactToken": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      },
                      "egiftThemeToken": {
                        "type": "string",
                        "id": 12,
                        "rule": "optional"
                      },
                      "egiftOrderSource": {
                        "type": "squareup.giftcard.model.GiftCard.EGiftOrderDetails.OrderSource",
                        "id": 13,
                        "rule": "optional"
                      },
                      "languageCode": {
                        "type": "string",
                        "id": 14,
                        "rule": "optional"
                      },
                      "recipientPhoneNumberId": {
                        "type": "string",
                        "id": 15,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DeliveryState": {
                        "values": {
                          "UNKNOWN": 0,
                          "PENDING": 1,
                          "ATTEMPTED": 2,
                          "BOUNCED": 3,
                          "CANCELED_DUE_TO_DELETED_RECIPIENT": 4,
                          "ENQUEUED": 5
                        }
                      },
                      "OrderSource": {
                        "values": {
                          "SOURCE_UNKNOWN": 0,
                          "EGIFT_FRONTEND": 1,
                          "POS": 2,
                          "API": 3,
                          "MARKETPLACES_API": 4
                        }
                      }
                    }
                  },
                  "GANSource": {
                    "values": {
                      "DO_NOT_USE_GAN_SOURCE": 0,
                      "SQUARE": 1,
                      "OTHER": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.CardType && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.AttributedMoney && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCard && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCard?.nested?.State && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCard?.nested?.Detail && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCard?.nested?.EGiftOrderDetails && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCard?.nested?.EGiftOrderDetails?.nested?.DeliveryState && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCard?.nested?.EGiftOrderDetails?.nested?.OrderSource && !$root.nested?.squareup?.nested?.giftcard?.nested?.model?.nested?.GiftCard?.nested?.GANSource) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CardType @ squareup/giftcard/model/giftcard.proto at 13:1
 */
export const CardType = $root.lookupEnum('squareup.giftcard.model.CardType').values;
/**
 * A simple pairing of a unit token and money amount.
 *
 * SOURCE AttributedMoney @ squareup/giftcard/model/giftcard.proto at 24:1
 */
export const AttributedMoney = $root.lookupType('squareup.giftcard.model.AttributedMoney');
fixType(AttributedMoney, {
  unitToken: {
    notEmpty: true
  },
  money: {
    required: true
  }
});
Builder.createAndAttachToType(AttributedMoney);
/**
 * SOURCE GiftCard @ squareup/giftcard/model/giftcard.proto at 29:1
 */
export const GiftCard = $root.lookupType('squareup.giftcard.model.GiftCard');
fixType(GiftCard, {
  token: {
    notEmpty: true
  },
  panFideliusToken: {
    notEmpty: true
  },
  panSuffix: {
    notEmpty: true
  },
  state: {
    required: true
  }
});
Builder.createAndAttachToType(GiftCard);
/**
 * See design doc for details of state changes on a Gift Card.
 *
 * https://docs.google.com/a/squareup.com/document/d/1SqEYVPz6a97Cbl5spb2NpemojS1rwBnQGNb9e3bdJes/edit#heading=h.ejexcb6648ui
 *
 * WARNING: Please do NOT re-order these states, or change their positional values.  These are
 * used to assert correct and allowed state transitions.
 *
 * SOURCE State @ squareup/giftcard/model/giftcard.proto at 38:3
 */
GiftCard.State = $root.lookupEnum('squareup.giftcard.model.GiftCard.State').values;
/**
 * SOURCE Detail @ squareup/giftcard/model/giftcard.proto at 93:3
 */
GiftCard.Detail = $root.lookupType('squareup.giftcard.model.GiftCard.Detail');
fixType(GiftCard.Detail);
Builder.createAndAttachToType(GiftCard.Detail);
/**
 * Details required for eGift delivery. ALL FIELDS should be populated after the GiftCard has
 * been registered, except where noted.
 *
 * SOURCE EGiftOrderDetails @ squareup/giftcard/model/giftcard.proto at 116:3
 */
GiftCard.EGiftOrderDetails = $root.lookupType('squareup.giftcard.model.GiftCard.EGiftOrderDetails');
fixType(GiftCard.EGiftOrderDetails);
Builder.createAndAttachToType(GiftCard.EGiftOrderDetails);
/**
 * !!! DO NOT RENAME !!! These enum names are persisted in the database!
 *
 * SOURCE DeliveryState @ squareup/giftcard/model/giftcard.proto at 135:5
 */
GiftCard.EGiftOrderDetails.DeliveryState = $root.lookupEnum('squareup.giftcard.model.GiftCard.EGiftOrderDetails.DeliveryState').values;
/**
 * SOURCE OrderSource @ squareup/giftcard/model/giftcard.proto at 164:5
 */
GiftCard.EGiftOrderDetails.OrderSource = $root.lookupEnum('squareup.giftcard.model.GiftCard.EGiftOrderDetails.OrderSource').values;
/**
 * SOURCE GANSource @ squareup/giftcard/model/giftcard.proto at 204:3
 */
GiftCard.GANSource = $root.lookupEnum('squareup.giftcard.model.GiftCard.GANSource').values;